const analyticsReducer = (state = {}, action) => {
  return state;
};

export default analyticsReducer;
